/**
 * 自动生成， 请不要手工修改！
 */

import { AbstractCompositeCoworkInfo } from "../cowork/AbstractCompositeCoworkInfo";
import { GeneralCoworkStats } from "../cowork/GeneralCoworkStats";
import { GeneralCoworkUserInfo } from "../cowork/GeneralCoworkUserInfo";
import { JsonTypeTagType } from "../../serialize/JsonTypeTagType";
import { TypeFactory } from "../../serialize/TypeFactory";
import { UserAd } from "./UserAd";

export abstract class AbstractCompositeUserAdInfo extends AbstractCompositeCoworkInfo<
  UserAd,
  GeneralCoworkStats,
  GeneralCoworkUserInfo,
  AbstractCompositeUserAdInfo
> {
  constructor() {
    super();
  }

  abstract getVisits(): number;

  public fillFromJson(json: Object, factory?: TypeFactory) {
    if (factory) {
      super.fillFromJson(json, factory);
    } else {
      super.fillFromJson(json);
    }
  }

  public fillToJson(json: Object, includeTypeTag = true) {
    super.fillToJson(json, includeTypeTag);

    if (includeTypeTag) {
      json["__type"] = "CompositeUserAdInfo";
    }
  }

  public getTypeId(): string {
    return "CompositeUserAdInfo";
  }

  public getClassName(): string {
    return "com.gong_wei.common.datatype.userad.CompositeUserAdInfo";
  }
}
